import React, { Component } from "react";

import { connect } from "react-redux";
import { getUsersLogs } from "../actions/usersLogsActions";
import PropTypes from "prop-types";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

export class UsersLogs extends Component {
  componentDidMount() {
    this.props.getUsersLogs();
  }

  render() {
    const { deviceLogs } = this.props.deviceLogs;

    const columns = [
      {
        dataField: "username",
        text: "Username",
        filter: textFilter()
      },
      {
        dataField: "userType",
        text: "User Type"
      },
      {
        dataField: "registrationTime",
        text: "Time Created"
      },
      {
        dataField: "deletionTime",
        text: "Deletion Time"
      },
      {
        dataField: "deviceName",
        text: "Device Name"
      },
      {
        dataField: "deviceMAC",
        text: "MAC Address",
        filter: textFilter()
      },
      {
        dataField: "userPassword",
        text: "Password"
      }
    ];

    return (
      <div>
        <BootstrapTable
          wrapperClasses="table-responsive ml-3"
          keyField="deviceLogId"
          data={deviceLogs}
          columns={columns}
          pagination={paginationFactory()}
          filter={filterFactory()}
        />
      </div>
    );
  }
}

UsersLogs.propTypes = {
  getUsersLogs: PropTypes.func.isRequired,
  deviceLogs: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  deviceLogs: state.userLogs,
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { getUsersLogs }
)(UsersLogs);
